import { useState } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Users, CalendarDays, LogOut, ShieldCheck, Menu, DollarSign, UserPlus, Kanban, Video } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/superadmin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/superadmin/photographers", label: "Photographers", icon: Users },
  { to: "/superadmin/events", label: "Events", icon: CalendarDays },
  { to: "/superadmin/leads", label: "Leads", icon: UserPlus },
  { to: "/superadmin/pricing", label: "Pricing", icon: DollarSign },
  { to: "/superadmin/crm", label: "CRM", icon: Kanban },
  { to: "/superadmin/video", label: "Live Video", icon: Video },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const inner = (
    <div className="flex flex-col h-full">
      <div className="px-6 py-6"><Logo /></div>
      <div className="mx-3 mb-4 glass rounded-xl px-4 py-3 flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-gold" /><span className="text-xs text-secondary-foreground">Super Admin Console</span></div>
      <nav className="flex-1 px-3 space-y-1">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`admin-nav-${n.label.toLowerCase()}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-gold/15 text-gold border border-gold/20" : "text-muted-foreground hover:text-white hover:bg-white/5"}`}>
            <n.icon className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3">
        <button data-testid="admin-logout" onClick={() => { logout(); navigate("/"); }} className="flex items-center gap-2 text-xs text-muted-foreground hover:text-destructive px-3 py-2"><LogOut className="w-3.5 h-3.5" /> Sign out</button>
      </div>
    </div>
  );

  return (
    <div className="app-shell min-h-screen bg-background flex">
      <aside className="hidden lg:flex w-64 shrink-0 border-r border-border bg-black/40 fixed inset-y-0">{inner}</aside>
      {open && (<div className="lg:hidden fixed inset-0 z-50"><div className="absolute inset-0 bg-black/70" onClick={() => setOpen(false)} /><aside className="absolute inset-y-0 left-0 w-64 bg-black border-r border-border">{inner}</aside></div>)}
      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="sticky top-0 z-40 glass-dark border-b border-border px-4 sm:px-8 py-3.5 flex items-center justify-between">
          <button className="lg:hidden text-white" onClick={() => setOpen(true)}><Menu /></button>
          <Link to="/" className="hidden lg:block text-xs text-muted-foreground hover:text-gold">← Back to site</Link>
          <div className="flex items-center gap-2 text-sm text-secondary-foreground"><div className="w-9 h-9 rounded-full bg-gold/20 border border-gold/30 flex items-center justify-center text-gold">{(user?.name || "A").charAt(0)}</div></div>
        </header>
        <main className="p-4 sm:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
